// Charge la base commune
import './common.js'

// Agencies Search Form
async function getAsForm ($f) {
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // gestion de la recherche d'agences la plus proche
  const $c = $('form[name="asForm"]')
  if ($c.length) {
    $c.waypoint(function () {
      $c.load()
      getAsForm($c)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })
})
